import { render } from "./kalio-job-offer-application-options.vue?vue&type=template&id=baa770e2"
import script from "./kalio-job-offer-application-options.vue?vue&type=script&lang=js"
export * from "./kalio-job-offer-application-options.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__